<template>
  <vx-card class="min-h-screen">
		<div class="flex flex-wrap">
			<div class="w-full md:w-1/3 p-5" v-for="(stat, index) in masters.stats" :key="index">
				<StatsCard :value="stat.value" :text="stat.text"/>
			</div>
		</div>
	</vx-card>
</template>

<script>
import api from '@/utils/api.js'

export default {
	data() {
		return {
			masters: {
				stats: [
				]
			}
		}
	},
	mounted() {
		const stats = ['brand-ambasador', 'campaign', 'redeem', 'campaign/active']
		const request = []
		stats.forEach(stat => {
			request.push(this.$axios.get(`${api.dashboard}/${stat}`))
		})

		Promise.all(request).then(res => {
			stats.forEach((stat, index) => {
				if(stat === 'brand-ambasador') stat = 'brand-ambassador'
				const text = stat.replaceAll('-', ' ').replaceAll('/', ' ')
				this.masters.stats.push({
					text,
					value: res[index].data.data
				})
			})
		})
	}
}
</script>

<style>

</style>